import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { Col, Row } from 'react-bootstrap';
import '../style.css';

const propTypes = exact({
  summary: PropTypes.object.isRequired,
});


const TrirSummary = (props) => {
  const { summary } = props;
  const {
    guaranteed,
    pto,
    paidNonLaborDuration,
    paidLaborDuration,
    paidTotalDuration,
  } = summary;

  return (
    <Row>
      <Col md={12}>
        <div className="pull-left trir-summary">
          <h3>Total Paid Hours:</h3>
          <h4> {paidTotalDuration.toString}</h4>
        </div>
        <div className="pull-left trir-summary">
          <h3>Paid Labor Hours:</h3>
          <h4> {paidLaborDuration.toString}</h4>
        </div>
        <div className="pull-left trir-summary">
          <h3>Paid Non-Labor Hours:</h3>
          <h4> {paidNonLaborDuration.toString}</h4>
        </div>
        <div className="pull-left trir-summary">
          <h3>PTO:</h3>
          <h4> {pto.toString}</h4>
        </div>
        <div className="pull-left trir-summary">
          <h3>Guaranteed:</h3>
          <h4> {guaranteed.toString}</h4>
        </div>
      </Col>
    </Row>
  );
};


TrirSummary.propTypes = propTypes;


export default TrirSummary;
